export enum EstadoEnum { REQUESTED, AWAITING_PAYMENT, APPROVED, RUNNING, FINISHED }

const idsEstadosEnum = new Map<EstadoEnum, string>();
idsEstadosEnum.set(EstadoEnum.REQUESTED, "REQUESTED");
idsEstadosEnum.set(EstadoEnum.AWAITING_PAYMENT, "AWAITING_PAYMENT");
idsEstadosEnum.set(EstadoEnum.APPROVED, "APPROVED");
idsEstadosEnum.set(EstadoEnum.RUNNING, "RUNNING");
idsEstadosEnum.set(EstadoEnum.FINISHED, "FINISHED");

const nombresEstadosEnum = new Map<EstadoEnum, string>();
nombresEstadosEnum.set(EstadoEnum.REQUESTED, "Requested");
nombresEstadosEnum.set(EstadoEnum.AWAITING_PAYMENT, "Awaiting payment");
nombresEstadosEnum.set(EstadoEnum.APPROVED, "Approved");
nombresEstadosEnum.set(EstadoEnum.RUNNING, "Running");
nombresEstadosEnum.set(EstadoEnum.FINISHED, "Finished");

export const obtenerIdEstado: (estado: EstadoEnum) => string = estado => idsEstadosEnum.get(estado) ?? "";
export const obtenerNombreEstado: (estado: EstadoEnum) => string = estado => nombresEstadosEnum.get(estado) ?? "";

export const obtenerNombresEstado: () => Array<[EstadoEnum, string]> = () => Array.from(nombresEstadosEnum.entries());
